import {useMemo} from 'react';
import {useRecoilValue} from 'recoil';
import classNames from 'classnames';
import {layerState} from '@src/store';
import AlertLayer from './AlertLayer';
import ConfirmLayer from './ConfirmLayer';
import ListLayer from './ListLayer';

function Layer () {
  const {open, type} = useRecoilValue(layerState);

  const layerNode = useMemo(() => {
    switch (type) {
      case 'ALERT':
        return <AlertLayer />;
      case 'CONFIRM':
        return <ConfirmLayer />;
      case 'LIST':
        return <ListLayer />;
      default:
        return null;
    }
  }, [type]);

  if (!open) {
    return null;
  }

  return (
    // eslint-disable-next-line @typescript-eslint/naming-convention
    <div className={classNames('dimmed_layer isPopupOpen', {layer_cancel: type === 'LIST'})}>{layerNode}</div>
  );
}

export default Layer;
